function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 34.807,
  cy: 34.808,
  r: 34,
  fill: "#de5b6b"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 9.752,
  strokeMiterlimit: 10,
  d: "M34.807 14.035v25.916m0 5.324v7.723"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h69.614v69.614H0z"
});

var SvgIconAlertColor = function SvgIconAlertColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconAlertColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-alert--color.02dd9f0b.svg";
export { ForwardRef as ReactComponent };